import { AwardingClient } from "@/utils/EvoClient";
import { DismissConversationNotificationDto } from "../dto";
import { AxiosResponse } from "axios";

const ENDPOINT = "c/dismiss-conversation-notification";

export default async function dismissConversationNotification(
  dto: DismissConversationNotificationDto
): Promise<string> {
  return ((await AwardingClient.post(ENDPOINT, dto)) as AxiosResponse).data.id;
}
